import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'get'

export default class OspreyImagesMetadata extends BaseAction {
    constructor() {
        const id = '818f8bba-cbda-49a2-badb-50f3be38ec2a'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
        this.noCache = true
    }

    getMetadata(fields) {
        if (!fields) {
            fields = ['base', 'image']
        }

        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-metadata.js